/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable react/prop-types */
import React from "react";

import PageHeading from "2g-page-heading";

import * as RENDERERS from "b2b/renderers";

const Renderer = ({ name, val }) => {
  const Rend = RENDERERS[name];
  return (
    <tr>
      <td
        style={{
          verticalAlign: "top",
          border: "1px solid #dfdfdf",
          padding: "10px",
          lineHeight: "1em"
        }}
      >
        &lt;{name} val=&#123;
        <span
          style={{
            maxWidth: "400px",
            textOverflow: "ellipsis",
            overflow: "hidden",
            display: "inline-block",
            whiteSpace: "nowrap",
            lineHeight: "1em",
            verticalAlign: "bottom",
            color: "#999"
          }}
        >
          {JSON.stringify(val)}
        </span>
        &#125; /&gt;
      </td>
      <td
        style={{
          verticalAlign: "top",
          border: "1px solid #dfdfdf",
          padding: "10px"
        }}
      >
        <Rend val={val} />
      </td>
      <td
        style={{
          verticalAlign: "top",
          border: "1px solid #dfdfdf",
          padding: "10px"
        }}
      >
        <Rend val={val} showPlaceholder />
      </td>
    </tr>
  );
};

const ZADOST = require("b2b-devel/zadosti/zadost.json");
const TYPY_ZDROJU = require("b2b-devel/zdroj/typyzdroje.json");
const DOPLNKOVE_SLUZBY = TYPY_ZDROJU[0].zdroje[0].produkty[0].doplnkoveSluzby;

export function RenderersExample() {
  return (
    <>
      <PageHeading>Renderers</PageHeading>
      <table style={{ borderSpacing: 0 }}>
        <tbody>
          <tr>
            <td>
              <pre>
                &lt;RendererHodinaInterval hodinaOd=&#123;2&#125;
                hodinaDo=&#123;12&#125; /&gt;
              </pre>
            </td>
            <td>
              <RENDERERS.RendererHodinaInterval hodinaOd={2} hodinaDo={12} />
            </td>
          </tr>
          <Renderer name="Aktivni" val={{ aktivni: false }} />
          <Renderer name="Aktivni" val={{ aktivni: true }} />
          <Renderer
            name="Aktivni"
            val={{
              aktivni: true,
              vylukaOd: new Date(2024, 1, 5).getTime(),
              vylukaDo: new Date(2024, 5, 18).getTime()
            }}
          />
          <Renderer name="AnoNe" val={false} />
          <Renderer name="AnoNe" val={true} />
          <Renderer
            name="CsEnNazev"
            val={{ nazevCs: "nazev cs", nazevEn: "nazev en" }}
          />
          <Renderer
            name="CsEnPopis"
            val={{ popisCs: "popis cs", popisEn: "popis en" }}
          />
          <Renderer
            name="CsEnVyznam"
            val={{ vyznamCs: "vyznam cs", vyznamEn: "vyznam en" }}
          />
          <Renderer name="Date" val={new Date().getTime()} />
          <Renderer name="DateTime" val={new Date().getTime()} />
          <Renderer name="DateAktivita" val={new Date().getTime()} />
          <Renderer name="DoplnkoveSluzby" val={DOPLNKOVE_SLUZBY} />
          <Renderer name="DoplnkoveSluzbyNazev" val={DOPLNKOVE_SLUZBY} />
          <Renderer name="Kolize" val={0} />
          <Renderer name="Kolize" val={1} />
          <Renderer
            name="Termin"
            val={{
              datumOd: new Date(2023, 5, 1, 6, 0, 0, 0).getTime(),
              datumDo: new Date(2023, 5, 1, 14, 0, 0, 0).getTime()
            }}
          />
          <Renderer
            name="Termin"
            val={{
              datumOd: new Date(2023, 5, 1, 6, 0, 0, 0).getTime(),
              datumDo: new Date(2023, 5, 2, 14, 0, 0, 0).getTime()
            }}
          />
          <Renderer name="Zadavatel" val={ZADOST.zadavatel} />
          <Renderer name="ZadostPoznamky" val={ZADOST.poznamky} />
          <Renderer name="ZadostPoznamkyItem" val={ZADOST.poznamky[0]} />
          <Renderer name="ZadostHistorie" val={ZADOST.historie} />
          <Renderer name="ZadostHistorieItem" val={ZADOST.historie[0]} />
          <Renderer
            name="ZadostHistorieItemPoznamka"
            val={{ label: "Popoznamka", poznamka: "Lorem ipsum dolor sit" }}
          />
          <Renderer name="ZadostStavLabel" val={ZADOST.stav} />
        </tbody>
      </table>
    </>
  );
}

RenderersExample.propTypes = {};

export default React.memo(RenderersExample);
